import "./customization-loader.css";

import { CustomizationLoaderImage } from "constants/Images";
import { Image } from 'react-bootstrap'

const CustomizationLoader = () => {
   return <Image src={CustomizationLoaderImage} alt='calender-icon' className='customization-data-loader' />
}
export default CustomizationLoader